import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import './LegalDocumentPage.css';

function LegalDocumentPage({ title, children }) {
  const { t } = useTranslation();

  return (
    <div className="legal-document-page">
      <header className="legal-header">
        <div className="legal-header-container">
          <Link to="/" className="back-button">
            ← {t('common.back') || 'Back'}
          </Link>
          <h1 className="legal-title">{title}</h1>
          <div className="legal-header-lang">
            <LanguageSwitcher />
          </div>
        </div>
      </header>

      <main className="legal-document-content">
        {children}
      </main>
    </div>
  );
}

export default LegalDocumentPage;
